import { QueryConfig } from "store/utils/query-config";

export const customerInvoicesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};

export function customerInvoicesQueryForBooking(bookingId: string): QueryConfig {
  return {
    query: { bookingId },
    options: { sortBy: ["createdAt"] },
  };
}

export function customerInvoicesQueryForCustomer(
  customerId: string
): QueryConfig {
  return {
    query: { customerId },
    options: { sortBy: ["-createdAt"] },
  };
}
